import { Modal, Pressable } from "react-native";
import styled from "styled-components/native";
import { colors, radius, font } from "@/lib/theme";
import { ModalContent } from "@/components/ContentWidth";

interface ConfirmSheetProps {
  visible: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const Sheet = styled.View`
  background-color: ${colors.white};
  border-top-left-radius: ${radius.xl}px;
  border-top-right-radius: ${radius.xl}px;
  padding: 24px;
  padding-bottom: 40px;
`;

const Title = styled.Text`
  font-size: 18px;
  font-weight: ${font.extrabold};
  color: ${colors.ink};
  text-align: center;
  margin-bottom: 8px;
`;

const Message = styled.Text`
  font-size: 14px;
  color: ${colors.inkSecondary};
  text-align: center;
  line-height: 20px;
  margin-bottom: 20px;
`;

const ConfirmBtn = styled.View<{ destructive?: boolean }>`
  background-color: ${(p) => p.destructive ? colors.danger : colors.brand};
  border-radius: ${radius.card}px;
  padding: 16px;
  align-items: center;
`;

const ConfirmBtnText = styled.Text`
  color: #fff;
  font-size: 16px;
  font-weight: ${font.bold};
`;

const CancelBtn = styled.View`
  padding: 14px;
  align-items: center;
  margin-top: 4px;
`;

const CancelBtnText = styled.Text`
  color: ${colors.inkMuted};
  font-size: 15px;
  font-weight: ${font.bold};
`;

export default function ConfirmSheet({
  visible,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  onCancel,
}: ConfirmSheetProps) {
  return (
    <Modal visible={visible} animationType="slide" transparent>
      <ModalContent onClose={onCancel}>
        <Sheet>
          <Title>{title}</Title>
          {message && <Message>{message}</Message>}
          <Pressable onPress={onConfirm} style={({ pressed }) => ({ opacity: pressed ? 0.9 : 1 })}>
            <ConfirmBtn destructive={destructive}>
              <ConfirmBtnText>{confirmLabel}</ConfirmBtnText>
            </ConfirmBtn>
          </Pressable>
          <Pressable onPress={onCancel} style={({ pressed }) => ({ opacity: pressed ? 0.7 : 1 })}>
            <CancelBtn>
              <CancelBtnText>{cancelLabel}</CancelBtnText>
            </CancelBtn>
          </Pressable>
        </Sheet>
      </ModalContent>
    </Modal>
  );
}
